module.exports = __webpack_public_path__ + "img/active_icon05.f2aa412b.png";